let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5e0T7")).then(() => parcelRequire('kbT1g'));